"use client"

import { useEffect } from "react"
import { HalamanSistem } from "@/modules/sistem/ui/halaman-sistem"

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return <HalamanSistem kode="500" rujukan={error.digest} onCobaLagi={reset} />
}
